import { last, sortBy } from 'lodash';

export const getLatestDeck = (decks: Deck[]) => last(sortBy(decks, 'updated_at'));
